import React from 'react';

const AdminSubIndustriesToolbar = ({
  searchQuery,
  onSearchChange,
  filterParentIndustry,
  onFilterParentIndustryChange,
  uniqueIndustries,
  onAddClick,
}) => (
  <div className="p-6 border-b border-gray-200 dark:border-gray-700">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="Search sub-industries..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
        />
        <select
          value={filterParentIndustry}
          onChange={(e) => onFilterParentIndustryChange(e.target.value)}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="all">All Parent Industries</option>
          {uniqueIndustries.map((ind) => (
            <option key={ind.id} value={ind.id}>
              {ind.displayName}
            </option>
          ))}
        </select>
      </div>
      <button
        type="button"
        onClick={onAddClick}
        className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-600"
      >
        <span className="mr-2">+</span>
        Add New Sub-Industry
      </button>
    </div>
  </div>
);

export default AdminSubIndustriesToolbar;


